import { render } from "./SalesOrderRemarksConfiguration.vue?vue&type=template&id=a757fcf0"
import script from "./SalesOrderRemarksConfiguration.vue?vue&type=script&lang=js"
export * from "./SalesOrderRemarksConfiguration.vue?vue&type=script&lang=js"

import "./SalesOrderRemarksConfiguration.vue?vue&type=style&index=0&id=a757fcf0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__